// Shared schema builders
import sharedAigSchemaBuilder from '@/views/checkouts/companies/Aig/shared/sharedAigSchema';
import sharedAllianzSchemaBuilder from '@/views/checkouts/companies/Allianz/shared/sharedAllianzSchema';
import sharedAnytimeSchemaBuilder from '@/views/checkouts/companies/Anytime/shared/sharedAnytimeSchema';
import sharedApeironSchemaBuilder from '@/views/checkouts/companies/Apeiron/shared/sharedApeironSchema';
import sharedAtlantikiSchemaBuilder from '@/views/checkouts/companies/Atlantiki/shared/sharedAtlantikiSchema';
import sharedCaravelaSchemaBuilder from '@/views/checkouts/companies/Caravela/shared/sharedCaravelaSchema';
import sharedDinamisSchemaBuilder from '@/views/checkouts/companies/Dinamis/shared/sharedDinamisSchema';
import sharedElpaSchemaBuilder from '@/views/checkouts/companies/Elpa/shared/sharedElpaSchema';
import sharedErgoSchemaBuilder from '@/views/checkouts/companies/Ergo/shared/sharedErgoSchema';
import sharedEthnikiSchemaBuilder from '@/views/checkouts/companies/Ethniki/shared/sharedEthnikiSchema';
import sharedEuroinsSchemaBuilder from '@/views/checkouts/companies/Euroins/shared/sharedEuroinsSchema';
import sharedEurolifeSchemaBuilder from '@/views/checkouts/companies/Eurolife/shared/sharedEurolifeSchema';
import sharedEuropaSchemaBuilder from '@/views/checkouts/companies/Europa/shared/sharedEuropaSchema';
import sharedGroupamaSchemaBuilder from '@/views/checkouts/companies/Groupama/shared/sharedGroupamaSchema';
import sharedHellasDirectSchemaBuilder from '@/views/checkouts/companies/HellasDirect/shared/sharedHellasDirectSchema';
import sharedInteramericanSchemaBuilder from '@/views/checkouts/companies/Interamerican/shared/sharedInteramericanSchema';
import sharedInterascoSchemaBuilder from '@/views/checkouts/companies/Interasco/shared/sharedInterascoSchema';
import sharedInterlifeSchemaBuilder from '@/views/checkouts/companies/Interlife/shared/sharedInterlifeSchema';
import sharedIntersalonikaSchemaBuilder from '@/views/checkouts/companies/Intersalonika/shared/sharedIntersalonikaSchema';
import sharedFallbackSchemaBuilder from '@/views/checkouts/companies/Fallback/shared/sharedFallBackSchema';


// Car schema builders
import carAigSchemaBuilder from '@/views/checkouts/companies/Aig/car/carSchema';
import carAllianzSchemaBuilder from '@/views/checkouts/companies/Allianz/car/carAllianzSchema';
import carAnytimeSchemaBuilder from '@/views/checkouts/companies/Anytime/car/carAnytimeSchema';
import carApeironSchemaBuilder from '@/views/checkouts/companies/Apeiron/car/carSchema';
import carAtlantikiSchemaBuilder from '@/views/checkouts/companies/Atlantiki/car/carAtlantikiSchema';
import carCaravelaSchemaBuilder from '@/views/checkouts/companies/Caravela/car/carSchema';
import carDinamisSchemaBuilder from '@/views/checkouts/companies/Dinamis/car/carDinamisSchema';
import carElpaSchemaBuilder from '@/views/checkouts/companies/Elpa/car/carSchema';
import carErgoSchemaBuilder from '@/views/checkouts/companies/Ergo/car/carErgoSchema';
import carEthnikiSchemaBuilder from '@/views/checkouts/companies/Ethniki/car/carEthnikiSchema';
import carEuroinsSchemaBuilder from '@/views/checkouts/companies/Euroins/car/carSchema';
import carEurolifeSchemaBuilder from '@/views/checkouts/companies/Eurolife/car/carEurolifeSchema';
import carEuropaSchemaBuilder from '@/views/checkouts/companies/Europa/car/carEuropaSchema';
import carGroupamaSchemaBuilder from '@/views/checkouts/companies/Groupama/car/carGroupamaSchema';
import carHellasDirectSchemaBuilder from '@/views/checkouts/companies/HellasDirect/car/carSchema';
import carInteramericanSchemaBuilder from '@/views/checkouts/companies/Interamerican/car/carInteramericanSchema';
import carInterascoSchemaBuilder from '@/views/checkouts/companies/Interasco/car/carSchema';
import carInterlifeSchemaBuilder from '@/views/checkouts/companies/Interlife/car/carSchema';
import carIntersalonikaSchemaBuilder from '@/views/checkouts/companies/Intersalonika/car/carIntersalonikaSchema';
import carFallbackSchemaBuilder from '@/views/checkouts/companies/Fallback/car/carSchema';

// Bike schema builders
import bikeAigSchemaBuilder from '@/views/checkouts/companies/Aig/bike/bikeSchema';
import bikeAllianzSchemaBuilder from '@/views/checkouts/companies/Allianz/bike/bikeAllianzSchema';
import bikeAnytimeSchemaBuilder from '@/views/checkouts/companies/Anytime/bike/bikeAnytimeSchema';
import bikeApeironSchemaBuilder from '@/views/checkouts/companies/Apeiron/bike/bikeSchema';
import bikeAtlantikiSchemaBuilder from '@/views/checkouts/companies/Atlantiki/bike/bikeAtlantikiSchema';
import bikeCaravelaSchemaBuilder from '@/views/checkouts/companies/Caravela/bike/bikeSchema';
import bikeDinamisSchemaBuilder from '@/views/checkouts/companies/Dinamis/bike/bikeDinamisSchema';
import bikeElpaSchemaBuilder from '@/views/checkouts/companies/Elpa/bike/bikeSchema';
import bikeErgoSchemaBuilder from '@/views/checkouts/companies/Ergo/bike/bikeErgoSchema';
import bikeEthnikiSchemaBuilder from '@/views/checkouts/companies/Ethniki/bike/bikeEthnikiSchema';
import bikeEuroinsSchemaBuilder from '@/views/checkouts/companies/Euroins/bike/bikeSchema';
import bikeEurolifeSchemaBuilder from '@/views/checkouts/companies/Eurolife/bike/bikeEurolifeSchema';
import bikeEuropaSchemaBuilder from '@/views/checkouts/companies/Europa/bike/bikeEuropaSchema';
import bikeGroupamaSchemaBuilder from '@/views/checkouts/companies/Groupama/bike/bikeGroupamaSchema';
import bikeHellasDirectSchemaBuilder from '@/views/checkouts/companies/HellasDirect/bike/bikeSchema';
import bikeInteramericanSchemaBuilder from '@/views/checkouts/companies/Interamerican/bike/bikeInteramericanSchema';
import bikeInterascoSchemaBuilder from '@/views/checkouts/companies/Interasco/bike/bikeSchema';
import bikeInterlifeSchemaBuilder from '@/views/checkouts/companies/Interlife/bike/bikeSchema';
import bikeIntersalonikaSchemaBuilder from '@/views/checkouts/companies/Intersalonika/bike/bikeIntersalonikaSchema';
import bikeFallbackSchemaBuilder from '@/views/checkouts/companies/Fallback/bike/bikeSchema';

export const CompanyIDs = Object.freeze({
    AIG: '0036410956c8428ae91c6092045edb5f',
    ANYTIME: 'dd72568afbbdba1fc385dea5f5e50ee6',
    APEIRON: '7d9878ee35d141de099988c6b0debb73',
    ALLIANZ: 'daeecec9cf10183852bbc1ff081f818b',
    ATLANTIKI: 'c36274d2c15266f09ba1dd0590f16c49',
    HELLAS_DIRECT: '1d6fd09cd661e60f663125c2e5bebd16',
    INTERSALONIKA: 'd70e04750b287a31a6f4665a5a19cf53',
    INTERLIFE: 'be0e25c854c0d5f0fcf17676414f97b2',
    INTERASCO: '7c91fc98f1d296593f8b62d6f2e22bce',
    INTERAMERICAN: 'e050bb6ef9a8a845a6f255c4a74b21db',
    GROUPAMA: '791ad2403efa8c621f703cef82c0ac8b',
    ERGO: 'e39cb41af6f06a18c094d425f89ac8a9',
    EUROPA: '742b6888a48684f65bf6c5e34da7ca99',
    EUROLIFE: '3fd5f4041c582c201be65a9bbe3730c6',
    EUROINS: '1b6c15db9e6387ae19b62376b076d29e',
    ETHNIKI: 'aadee4bdbf4837ba8ad23efd79ec5cbb',
    ELPA: 'b3de88e13ccd62b591907a01fc8247d6',
    DINAMIS: '26f7dfa8a5de821f632190c674082751',
    CARAVELA: 'a6b361933c1146cd6e61e1c66be9325f',
});

export const SharedFallback = () =>
  import('@/views/checkouts/companies/Fallback/shared/sharedFallback.vue');
export const CarFallback = () => import('@/views/checkouts/companies/Fallback/car/carFallback.vue');
export const BikeFallback = () => import('@/views/checkouts/companies/Fallback/bike/bikeFallback.vue');
export const CarFallbackSchema = carFallbackSchemaBuilder;
export const BikeFallbackSchema = bikeFallbackSchemaBuilder;
export const SharedFallBackSchema = sharedFallbackSchemaBuilder;

// Shared components (used for non-easybuy car)
export const companyComponents = Object.freeze({
  [CompanyIDs.AIG]: () => import('@/views/checkouts/companies/Aig/shared/sharedAig.vue'),
  [CompanyIDs.ANYTIME]: () => import('@/views/checkouts/companies/Anytime/shared/sharedAnytime.vue'),
  [CompanyIDs.ALLIANZ]: () => import('@/views/checkouts/companies/Allianz/shared/sharedAllianz.vue'),
  [CompanyIDs.APEIRON]: () => import('@/views/checkouts/companies/Apeiron/shared/sharedApeiron.vue'),
  [CompanyIDs.ATLANTIKI]: () => import('@/views/checkouts/companies/Atlantiki/shared/sharedAtlantiki.vue'),
  [CompanyIDs.HELLAS_DIRECT]: () => import('@/views/checkouts/companies/HellasDirect/shared/sharedHellasDirect.vue'),
  [CompanyIDs.INTERSALONIKA]: () => import('@/views/checkouts/companies/Intersalonika/shared/sharedIntersalonika.vue'),
  [CompanyIDs.INTERLIFE]: () => import('@/views/checkouts/companies/Interlife/shared/sharedInterlife.vue'),
  [CompanyIDs.INTERASCO]: () => import('@/views/checkouts/companies/Interasco/shared/sharedInterasco.vue'),
  [CompanyIDs.INTERAMERICAN]: () => import('@/views/checkouts/companies/Interamerican/shared/sharedInteramerican.vue'),
  [CompanyIDs.GROUPAMA]: () => import('@/views/checkouts/companies/Groupama/shared/sharedGroupama.vue'),
  [CompanyIDs.ERGO]: () => import('@/views/checkouts/companies/Ergo/shared/sharedErgo.vue'),
  [CompanyIDs.EUROPA]: () => import('@/views/checkouts/companies/Europa/shared/sharedEuropa.vue'),
  [CompanyIDs.EUROLIFE]: () => import('@/views/checkouts/companies/Eurolife/shared/sharedEurolife.vue'),
  [CompanyIDs.EUROINS]: () => import('@/views/checkouts/companies/Euroins/shared/sharedEuroins.vue'),
  [CompanyIDs.ETHNIKI]: () => import('@/views/checkouts/companies/Ethniki/shared/sharedEthniki.vue'),
  [CompanyIDs.ELPA]: () => import('@/views/checkouts/companies/Elpa/shared/sharedElpa.vue'),
  [CompanyIDs.DINAMIS]: () => import('@/views/checkouts/companies/Dinamis/shared/sharedDinamis.vue'),
  [CompanyIDs.CARAVELA]: () => import('@/views/checkouts/companies/Caravela/shared/sharedCaravela.vue'),
});

// Car-specific components (easybuy car)
export const carCompanyComponents = Object.freeze({
  [CompanyIDs.AIG]: () => import('@/views/checkouts/companies/Aig/car/carAig.vue'),
  [CompanyIDs.ANYTIME]: () => import('@/views/checkouts/companies/Anytime/car/carAnytime.vue'),
  [CompanyIDs.ALLIANZ]: () => import('@/views/checkouts/companies/Allianz/car/carAllianz.vue'),
  [CompanyIDs.APEIRON]: () => import('@/views/checkouts/companies/Apeiron/car/carApeiron.vue'),
  [CompanyIDs.ATLANTIKI]: () => import('@/views/checkouts/companies/Atlantiki/car/carAtlantiki.vue'),
  [CompanyIDs.HELLAS_DIRECT]: () => import('@/views/checkouts/companies/HellasDirect/car/carHellasDirect.vue'),
  [CompanyIDs.INTERSALONIKA]: () => import('@/views/checkouts/companies/Intersalonika/car/carIntersalonika.vue'),
  [CompanyIDs.INTERLIFE]: () => import('@/views/checkouts/companies/Interlife/car/carInterlife.vue'),
  [CompanyIDs.INTERASCO]: () => import('@/views/checkouts/companies/Interasco/car/carInterasco.vue'),
  [CompanyIDs.INTERAMERICAN]: () => import('@/views/checkouts/companies/Interamerican/car/carInteramerican.vue'),
  [CompanyIDs.GROUPAMA]: () => import('@/views/checkouts/companies/Groupama/car/carGroupama.vue'),
  [CompanyIDs.ERGO]: () => import('@/views/checkouts/companies/Ergo/car/carErgo.vue'),
  [CompanyIDs.EUROPA]: () => import('@/views/checkouts/companies/Europa/car/carEuropa.vue'),
  [CompanyIDs.EUROLIFE]: () => import('@/views/checkouts/companies/Eurolife/car/carEurolife.vue'),
  [CompanyIDs.EUROINS]: () => import('@/views/checkouts/companies/Euroins/car/carEuroins.vue'),
  [CompanyIDs.ETHNIKI]: () => import('@/views/checkouts/companies/Ethniki/car/carEthniki.vue'),
  [CompanyIDs.ELPA]: () => import('@/views/checkouts/companies/Elpa/car/carElpa.vue'),
  [CompanyIDs.DINAMIS]: () => import('@/views/checkouts/companies/Dinamis/car/carDinamis.vue'),
  [CompanyIDs.CARAVELA]: () => import('@/views/checkouts/companies/Caravela/car/carCaravela.vue'),
});

// Bike-specific components
export const bikeCompanyComponents = Object.freeze({
  [CompanyIDs.AIG]: () => import('@/views/checkouts/companies/Aig/bike/bikeAig.vue'),
  [CompanyIDs.ANYTIME]: () => import('@/views/checkouts/companies/Anytime/bike/bikeAnytime.vue'),
  [CompanyIDs.ALLIANZ]: () => import('@/views/checkouts/companies/Allianz/bike/bikeAllianz.vue'),
  [CompanyIDs.APEIRON]: () => import('@/views/checkouts/companies/Apeiron/bike/bikeApeiron.vue'),
  [CompanyIDs.ATLANTIKI]: () => import('@/views/checkouts/companies/Atlantiki/bike/bikeAtlantiki.vue'),
  [CompanyIDs.HELLAS_DIRECT]: () => import('@/views/checkouts/companies/HellasDirect/bike/bikeHellasDirect.vue'),
  [CompanyIDs.INTERSALONIKA]: () => import('@/views/checkouts/companies/Intersalonika/bike/bikeIntersalonika.vue'),
  [CompanyIDs.INTERLIFE]: () => import('@/views/checkouts/companies/Interlife/bike/bikeInterlife.vue'),
  [CompanyIDs.INTERASCO]: () => import('@/views/checkouts/companies/Interasco/bike/bikeInterasco.vue'),
  [CompanyIDs.INTERAMERICAN]: () => import('@/views/checkouts/companies/Interamerican/bike/bikeInteramerican.vue'),
  [CompanyIDs.GROUPAMA]: () => import('@/views/checkouts/companies/Groupama/bike/bikeGroupama.vue'),
  [CompanyIDs.ERGO]: () => import('@/views/checkouts/companies/Ergo/bike/bikeErgo.vue'),
  [CompanyIDs.EUROPA]: () => import('@/views/checkouts/companies/Europa/bike/bikeEuropa.vue'),
  [CompanyIDs.EUROLIFE]: () => import('@/views/checkouts/companies/Eurolife/bike/bikeEurolife.vue'),
  [CompanyIDs.EUROINS]: () => import('@/views/checkouts/companies/Euroins/bike/bikeEuroins.vue'),
  [CompanyIDs.ETHNIKI]: () => import('@/views/checkouts/companies/Ethniki/bike/bikeEthniki.vue'),
  [CompanyIDs.ELPA]: () => import('@/views/checkouts/companies/Elpa/bike/bikeElpa.vue'),
  [CompanyIDs.DINAMIS]: () => import('@/views/checkouts/companies/Dinamis/bike/bikeDinamis.vue'),
  [CompanyIDs.CARAVELA]: () => import('@/views/checkouts/companies/Caravela/bike/bikeCaravela.vue'),
});

// Shared schemas (non-easybuy car — base fields only)
export const companySchemas = Object.freeze({
  [CompanyIDs.AIG]: sharedAigSchemaBuilder,
  [CompanyIDs.ANYTIME]: sharedAnytimeSchemaBuilder,
  [CompanyIDs.ALLIANZ]: sharedAllianzSchemaBuilder,
  [CompanyIDs.APEIRON]: sharedApeironSchemaBuilder,
  [CompanyIDs.ATLANTIKI]: sharedAtlantikiSchemaBuilder,
  [CompanyIDs.HELLAS_DIRECT]: sharedHellasDirectSchemaBuilder,
  [CompanyIDs.INTERSALONIKA]: sharedIntersalonikaSchemaBuilder,
  [CompanyIDs.INTERLIFE]: sharedInterlifeSchemaBuilder,
  [CompanyIDs.INTERASCO]: sharedInterascoSchemaBuilder,
  [CompanyIDs.INTERAMERICAN]: sharedInteramericanSchemaBuilder,
  [CompanyIDs.GROUPAMA]: sharedGroupamaSchemaBuilder,
  [CompanyIDs.ERGO]: sharedErgoSchemaBuilder,
  [CompanyIDs.EUROPA]: sharedEuropaSchemaBuilder,
  [CompanyIDs.EUROLIFE]: sharedEurolifeSchemaBuilder,
  [CompanyIDs.EUROINS]: sharedEuroinsSchemaBuilder,
  [CompanyIDs.ETHNIKI]: sharedEthnikiSchemaBuilder,
  [CompanyIDs.ELPA]: sharedElpaSchemaBuilder,
  [CompanyIDs.DINAMIS]: sharedDinamisSchemaBuilder,
  [CompanyIDs.CARAVELA]: sharedCaravelaSchemaBuilder,
});

// Car-specific schemas (easybuy car)
export const carCompanySchemas = Object.freeze({
  [CompanyIDs.AIG]: carAigSchemaBuilder,
  [CompanyIDs.ANYTIME]: carAnytimeSchemaBuilder,
  [CompanyIDs.ALLIANZ]: carAllianzSchemaBuilder,
  [CompanyIDs.APEIRON]: carApeironSchemaBuilder,
  [CompanyIDs.ATLANTIKI]: carAtlantikiSchemaBuilder,
  [CompanyIDs.HELLAS_DIRECT]: carHellasDirectSchemaBuilder,
  [CompanyIDs.INTERSALONIKA]: carIntersalonikaSchemaBuilder,
  [CompanyIDs.INTERLIFE]: carInterlifeSchemaBuilder,
  [CompanyIDs.INTERASCO]: carInterascoSchemaBuilder,
  [CompanyIDs.INTERAMERICAN]: carInteramericanSchemaBuilder,
  [CompanyIDs.GROUPAMA]: carGroupamaSchemaBuilder,
  [CompanyIDs.ERGO]: carErgoSchemaBuilder,
  [CompanyIDs.EUROPA]: carEuropaSchemaBuilder,
  [CompanyIDs.EUROLIFE]: carEurolifeSchemaBuilder,
  [CompanyIDs.EUROINS]: carEuroinsSchemaBuilder,
  [CompanyIDs.ETHNIKI]: carEthnikiSchemaBuilder,
  [CompanyIDs.ELPA]: carElpaSchemaBuilder,
  [CompanyIDs.DINAMIS]: carDinamisSchemaBuilder,
  [CompanyIDs.CARAVELA]: carCaravelaSchemaBuilder,
});

// Bike-specific schemas
export const bikeCompanySchemas = Object.freeze({
  [CompanyIDs.AIG]: bikeAigSchemaBuilder,
  [CompanyIDs.ANYTIME]: bikeAnytimeSchemaBuilder,
  [CompanyIDs.ALLIANZ]: bikeAllianzSchemaBuilder,
  [CompanyIDs.APEIRON]: bikeApeironSchemaBuilder,
  [CompanyIDs.ATLANTIKI]: bikeAtlantikiSchemaBuilder,
  [CompanyIDs.HELLAS_DIRECT]: bikeHellasDirectSchemaBuilder,
  [CompanyIDs.INTERSALONIKA]: bikeIntersalonikaSchemaBuilder,
  [CompanyIDs.INTERLIFE]: bikeInterlifeSchemaBuilder,
  [CompanyIDs.INTERASCO]: bikeInterascoSchemaBuilder,
  [CompanyIDs.INTERAMERICAN]: bikeInteramericanSchemaBuilder,
  [CompanyIDs.GROUPAMA]: bikeGroupamaSchemaBuilder,
  [CompanyIDs.ERGO]: bikeErgoSchemaBuilder,
  [CompanyIDs.EUROPA]: bikeEuropaSchemaBuilder,
  [CompanyIDs.EUROLIFE]: bikeEurolifeSchemaBuilder,
  [CompanyIDs.EUROINS]: bikeEuroinsSchemaBuilder,
  [CompanyIDs.ETHNIKI]: bikeEthnikiSchemaBuilder,
  [CompanyIDs.ELPA]: bikeElpaSchemaBuilder,
  [CompanyIDs.DINAMIS]: bikeDinamisSchemaBuilder,
  [CompanyIDs.CARAVELA]: bikeCaravelaSchemaBuilder,
});
